import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

    @Input() labels : any;
    @Input() currentLabel : string;
    @Input() isRequired : boolean = true;
    @Input() classLabel : string = "main-label";
    @Input() iconBefore : string = "";
    @Input() simulation : boolean;
    @Input() isDisabled : boolean = false;

    currentLabelTooltip : string;
    currentLabelName : string;

    constructor() { }

    ngOnInit() {
        this.setLabels();
    }

    ngOnChanges() {
        this.setLabels();
    }

    setLabels() {
        if (!this.simulation) {
            this.setLabelsDiagnostic();
        } else {
            this.setLabelsSimulation();
        }
    }

    setLabelsDiagnostic() {
        this.currentLabelTooltip = this.getLabelProperty("tooltip");
        this.currentLabelName = this.getLabelProperty("libelle");
    }

    setLabelsSimulation() {
        this.currentLabelTooltip = this.getLabelProperty("tooltipSimu");
        this.currentLabelName = this.getLabelProperty("libelleSimu");
    }

    getLabelProperty(property : string) {
        let result = "";
        if (this.labels && this.labels[this.currentLabel] && this.labels[this.currentLabel][property]) {
            result = this.labels[this.currentLabel][property];
        }
        return result;
    }
}
